import React, { useState } from 'react'
import { ArrowDown } from '../media/ArrowDown'
import { ArrowUp } from '../media/ArrowUp'
import cn from 'classnames'

export const Table = ({
  children,
  buttonText,
  title,
  tableData,
  cols,
  defaultOpen = false
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <>
      <div
        className={cn(
          'grid transition-[grid-template-rows] duration-1000 ease-in-out',
          {
            'grid-rows-[0fr]': !isOpen,
            'grid-rows-[1fr]': isOpen
          }
        )}
      >
        <div className="min-h-0 overflow-hidden">
          <h1
            className={`mb-[40px] lg:mt-[100px] lg:mb-12 text-[#FBFBFC] text-4xl md:text-[60px] font-medium leading-tight
              lg:text-center`}
          >
            {title}
          </h1>
          <div
            className={`mx-auto max-w-[1200] text-white flex flex-col gap-y-3 min-w-[280px] mb-[40px]
              lg:w-max lg:opacity-100 lg:rounded-[60px] lg:p-[60px] lg:bg-[#1B2126] lg:mb-5
              `}
          >
            {tableData.map((rowData, rowIndex) => (
              <div
                key={rowData.name + rowIndex}
                className={cn(
                  `opacity-100 rounded-[20px] bg-[#1B2126] py-5 px-6 text-xs flex flex-col gap-5
                   lg:opacity-none lg:rounded-none lg:bg-none lg:flex-row lg:gap-[30px] lg:pt-[30px] lg:text-sm lg:py-0 lg:px-0`,
                  {
                    'lg:border-b-2 lg:border-dashed lg:border-white/20 lg:pb-[30px]':
                      rowIndex !== tableData.length - 1
                  }
                )}
              >
                {Object.entries(rowData).map(([colKey, cellData]) => (
                  <React.Fragment key={colKey}>
                    {cols[colKey].renderCell(cellData, rowIndex)}
                  </React.Fragment>
                ))}
              </div>
            ))}
          </div>

          <div className="text-center">
            <button
              onClick={() => setIsOpen(false)}
              className="mx-auto min-w-[280px] sm:min-w-[188px] text-white px-8 py-6 rounded-full border border-[#FFFFFF4D] flex justify-center items-center gap-[10px] hover:opacity-60"
            >
              Скрыть
              <ArrowUp />
            </button>
          </div>
        </div>
      </div>

      {!isOpen && (
        <>
          {children}

          <div className="text-center">
            <button
              onClick={() => setIsOpen(true)}
              className="mx-auto max-w-[280px] sm:max-w-none text-white px-8 py-6 rounded-full border border-[#FFFFFF4D] flex items-center gap-[10px] hover:opacity-60"
            >
              <span>🔥</span>
              {buttonText}
              <ArrowDown />
            </button>
          </div>
        </>
      )}
    </>
  )
}
